import md5 from 'md5'

export { md5 }
